import { isPostHogAvailable } from "./posthog-utils"

const trackEvent = (event, properties, additionalProperties = {}) => {
  trackPostHogEvent(event, properties)
  trackMixpanelEvent(event, properties, additionalProperties)
  trackGoogleEvent(event, properties)
}

const trackGoogleEvent = (event, properties) => {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({ "event": event, "type": "wildgoose",  ...properties })
  }
}

const trackPostHogEvent = (event, properties) => {
  if (isPostHogAvailable()) {
    posthog.capture(event, { ...properties })
  }
}

const trackMixpanelEvent = (event, properties, additionalProperties) => {
  if (typeof mixpanel !== 'undefined') {
    mixpanel.track(event, { ...properties }, { ...additionalProperties })
  }
}

export { trackEvent, trackGoogleEvent, trackPostHogEvent, trackMixpanelEvent }